import { Fragment, useContext, useEffect, useState } from "react";
import { getUniqueFamiliesByLowestPrice, searchClient } from "../../Layout/Common/algoliaInstantLib";
import { isValidArray } from "../../Layout/Common/common";
import { ProductCardAlgolia } from "../../Layout/Common/productCardAlgolia";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { GlobalContext } from "../../Context/GlobalContext";
import { Link } from "react-router-dom";
import { PAGES } from "../../routeConfig";

export const ClearanceProductAlgolia = () => {
  const { algoliaProducts } = useContext(GlobalContext);
  const [productHit, setProductHit] = useState();
  useEffect(() => {
    if (algoliaProducts && isValidArray(algoliaProducts["CLEARANCEPRODUCTS"])) {
      setProductHit(algoliaProducts["CLEARANCEPRODUCTS"]);
    } else {
      // fetchClearanceProductsAlgolia();
    }
  }, [algoliaProducts]);

  return (
    <Fragment>
      {isValidArray(productHit) && (
        <section className="products-section">
          <div className="container-fluid container-lg">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h2>Clearance Products</h2>
                  <Link to={PAGES.CLEARANCE_CT} className="text-decoration-underline text-uppercase">
                    View All
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="row row-spacing">
                  {isValidArray(productHit) &&
                    productHit.slice(0, 8).map((item, idx) => (
                      // getUniqueFamiliesByLowestPrice stamps a stable `key` (familyId/sku/productId)
                      // on every item, so prefer it over the index - same pattern as SearchResultItems.
                      <div
                        className="col-6 col-sm-6 col-md-4 col-lg-3 mt-3 mt-lg-4"
                        key={item.key ?? `clearance-${idx}`}
                      >
                        <ProductCardAlgolia data={item} />
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};
